import { render, staticRenderFns } from "./Best.vue?vue&type=template&id=4695584c&scoped=true"
import script from "./Best.vue?vue&type=script&lang=js"
export * from "./Best.vue?vue&type=script&lang=js"
import style0 from "./Best.vue?vue&type=style&index=0&id=4695584c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4695584c",
  null
  
)

export default component.exports